module.exports = __webpack_public_path__ + "static/img/9.1400af6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/eng/9.png
// module id = 4Yjj
// module chunks = 0